import { API_BASE_URL, WS_BASE_URL } from "@/utils/api";

interface Config {
  api: {
    url: string;
  };
  ws: {
    url: string;
    enabled: boolean;
  };
}

const isDevelopment = process.env.NODE_ENV === "development";

// Helper function to ensure WebSocket uses WSS for HTTPS connections
const getWebSocketUrl = (): string => {
  const baseUrl = WS_BASE_URL;
  
  // If running in browser and page is HTTPS, ensure WebSocket uses WSS
  if (typeof window !== "undefined" && window.location.protocol === "https:") {
    return baseUrl.replace(/^ws:/, "wss:");
  }
  
  return baseUrl;
};

const config: Config = {
  api: {
    url: API_BASE_URL,
  },
  ws: {
    url: getWebSocketUrl(),
    enabled: process.env.NEXT_PUBLIC_DEMO_MODE !== "true", // Only disable in demo mode
  },
};

export default config;

// Export individual config values for direct imports
export const API_URL = config.api.url;
export const WS_URL = config.ws.url;
export const WS_ENABLED = config.ws.enabled;
